<template>
  <v-data-table
    @click:row="expandRow"
    v-if="defaultServiceValuesFields"
    :headers="headers"
    :expanded.sync="expanded"
    :items="defaultServiceValuesFields.service_contracts"
    class="clickable mt-5 caption"
    item-key="type"
    hide-default-footer
    disable-pagination
    disable-sort
  >
    <template v-slot:[`item.type`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div class="mw-150 text-truncate" v-bind="attrs" v-on="on">
            {{ $t(`type.${item.type}`) }}
          </div>
        </template>
        <span>{{ $t(`type.${item.type}`) }}</span>
      </v-tooltip>
    </template>

    <template v-slot:[`item.price`]="{ item }">
      {{ formatMoney(item.price) }}
    </template>

    <template v-slot:[`item.host_tax`]="{ item }">
      {{ item.host_tax }}%
    </template>

    <template v-slot:[`item.discount`]="{ item }">
      {{ item.discount }}%
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <v-btn @click.prevent="editLine(item.type)" icon>
        <v-icon color="primary" small>mdi-pencil-outline</v-icon>
      </v-btn>
      <v-btn @click.prevent="deleteLine(item.type)" icon>
        <v-icon color="red" small>mdi-close-circle-outline</v-icon>
      </v-btn>
    </template>

    <template v-slot:[`expanded-item`]="{ headers, item }">
      <TableServiceDetails :headers="headers" :item="item" />
    </template>
  </v-data-table>
</template>

<script>
import { tableServiceValuesHeaders } from './tableServiceValuesHeaders'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { catalogMonetary } from '@/util/catalog'

import TableServiceDetails from './TableServiceDetails'

export default {
  name: 'TableServiceValues',

  components: {
    TableServiceDetails,
  },

  computed: {
    ...mapGetters(['defaultServiceValuesFields']),

    contracts() {
      return this.defaultServiceValuesFields.service_contracts
    },
  },

  methods: {
    ...mapActions(['openModal', 'checkSelectedTypes', 'checkSelectedTypes']),
    ...mapMutations(['setDefaultServiceValuesFields', 'setServiceContract']),

    deleteLine(type) {
      const index = this.defaultServiceValuesFields.service_contracts
        .map((item) => item.type)
        .indexOf(type)

      this.contracts.splice(index, 1)
      this.setDefaultServiceValuesFields({ service_contracts: this.contracts })
      this.checkSelectedTypes()
    },

    editLine(type) {
      const index = this.defaultServiceValuesFields.service_contracts
        .map((item) => item.type)
        .indexOf(type)

      const line = { index }

      const serviceContracts =
        this.defaultServiceValuesFields.service_contracts[index]

      const serviceContractWithIndex = Object.assign(line, serviceContracts)

      this.setServiceContract(serviceContractWithIndex)
      this.openModal('EDIT_ITEM_DEFAULT_SERVICE_VALUES')
    },

    expandRow(item) {
      this.expanded = item === this.expanded[0] ? [] : [item]
    },

    formatMoney(amount) {
      return catalogMonetary(parseFloat(amount))
    }
  },

  data() {
    return {
      expanded: [],
      headers: tableServiceValuesHeaders,
    }
  },
}
</script>
